<template>
  <div class="svg-file-picker">
    <el-button size="mini" type="primary" @click="handleSelectFile" style="margin-bottom: 8px;">
      选择SVG文件
    </el-button>
    <!-- <el-input
      type="textarea"
      v-model="localValue"
      :rows="rows"
      :placeholder="placeholder"
    /> -->
  </div>
</template>

<script>
export default {
  name: 'SvgFilePicker',
  props: {
    value: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 3
    },
    placeholder: {
      type: String,
      default: '请选择SVG文件或直接输入SVG源码'
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleSelectFile() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.svg'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload = (event) => {
            this.localValue = event.target.result
          }
          reader.readAsText(file)
        }
      }
      input.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-file-picker {
  width: 100%;
}
</style>

